export const Card = ({ children, glow, sx, c, delay = 0 }) => (
  <div className="wm-card" style={{
    borderRadius: 16, border: `1px solid ${c.border}`, padding: 24,
    background: c.card, boxShadow: glow ? c.glow : c.cardShadow,
    transition: "all 0.3s cubic-bezier(0.25,0.1,0.25,1)",
    animation: `fadeSlideUp 0.5s cubic-bezier(0.25,0.1,0.25,1) ${delay}s both`,
    ...sx,
  }}>{children}</div>
);
